import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FieldDefinition } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { UrlQueryParams } from '../../../../../core/query/entities/url-query-params.entity';
import { GenerateQueryParamsFromAdvancedSearchTerm } from '../../../../../core/query/helpers/query-params-generators.helper';
import { SimpleFieldValue } from '../../../../entities/field-values/field-type-values.entity';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    selector: 'sh-date-readonly-field',
    templateUrl: './date-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShDateReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent {
    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    getSearchRouterParams(fieldDefinition: FieldDefinition, value: SimpleFieldValue): UrlQueryParams {
        const dateValue = `[${value} TO ${value}]`;
        return GenerateQueryParamsFromAdvancedSearchTerm(fieldDefinition.DottedKey, [dateValue]);
    }
}
